import Component from '@glimmer/component';
import { action } from '@ember/object';
import dispatcher from 'mewe/dispatcher';

export default class SidebarRightMyworld extends Component {

  @action
  createNewChat() {
    dispatcher.dispatch('chat', 'createNewChat');
  }

}
